import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Calendar } from 'lucide-react';
import { InteriorSlide, SlideHeader } from './SlideShell';
import type { SlideProps } from './SlideShell';
export function Slide08Expansion({
  index
}: SlideProps) {
  return <InteriorSlide data-id="element-139">
      <SlideHeader eyebrow="Asset Lifespan Recommendation" data-id="element-140">
        The teaser needs freshness sooner than the trailer
      </SlideHeader>

      <div className="flex-1 flex flex-col justify-center max-w-5xl mx-auto w-full gap-8" data-id="element-141">
        {/* Teaser Card */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.3,
        duration: 0.6
      }} className="bg-white rounded-2xl shadow-sm border border-black/5 p-8 flex flex-col md:flex-row items-center gap-8" data-id="element-142">
          <div className="flex-1" data-id="element-143">
            <div className="flex items-center gap-3 mb-4" data-id="element-144">
              <div className="h-10 w-10 rounded-full bg-[var(--surface)] flex items-center justify-center text-[var(--brand)]" data-id="element-145">
                <Clock className="h-5 w-5" data-id="element-146" />
              </div>
              <h3 className="text-2xl font-bold text-[var(--fg)]" data-id="element-147">
                Master Teaser
              </h3>
            </div>
            <p className="text-[var(--muted)] leading-relaxed mb-6" data-id="element-148">
              Can support up to 6 campaign adaptations. After 6 campaigns, it
              should receive a more substantial update than a simple facelift.
            </p>
            <div className="inline-flex items-center gap-2 bg-[var(--surface)] px-4 py-2 rounded-lg text-sm font-bold text-[var(--brand)]" data-id="element-149">
              Update cost: €1,250 every 6 months
            </div>
          </div>

          <div className="w-full md:w-1/2" data-id="element-150">
            <div className="h-4 bg-black/5 rounded-full overflow-hidden" data-id="element-151">
              <motion.div initial={{
              width: 0
            }} animate={{
              width: '50%'
            }} transition={{
              delay: 0.6,
              duration: 1
            }} className="h-full bg-[var(--brand)] rounded-full" data-id="element-152" />
            </div>
            <div className="flex justify-between mt-2 text-xs font-bold text-[var(--muted)] uppercase tracking-wider" data-id="element-153">
              <span data-id="element-154">Month 1</span>
              <span data-id="element-155">Month 6</span>
              <span data-id="element-156">Month 12</span>
            </div>
          </div>
        </motion.div>

        {/* Trailer Card */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.5,
        duration: 0.6
      }} className="bg-white rounded-2xl shadow-sm border border-black/5 p-8 flex flex-col md:flex-row items-center gap-8" data-id="element-157">
          <div className="flex-1" data-id="element-158">
            <div className="flex items-center gap-3 mb-4" data-id="element-159">
              <div className="h-10 w-10 rounded-full bg-[var(--surface)] flex items-center justify-center text-[var(--fg)]" data-id="element-160">
                <Calendar className="h-5 w-5" data-id="element-161" />
              </div>
              <h3 className="text-2xl font-bold text-[var(--fg)]" data-id="element-162">
                Master Trailer / Microsite
              </h3>
            </div>
            <p className="text-[var(--muted)] leading-relaxed mb-6" data-id="element-163">
              Can support up to 12 months of campaign activity. After 12 months,
              it should receive a larger overhaul preparing the next annual
              cycle.
            </p>
            <div className="inline-flex items-center gap-2 bg-[var(--surface)] px-4 py-2 rounded-lg text-sm font-bold text-[var(--fg)]" data-id="element-164">
              Update cost: €2,250 every 12 months
            </div>
          </div>

          <div className="w-full md:w-1/2" data-id="element-165">
            <div className="h-4 bg-black/5 rounded-full overflow-hidden" data-id="element-166">
              <motion.div initial={{
              width: 0
            }} animate={{
              width: '100%'
            }} transition={{
              delay: 0.8,
              duration: 1.5
            }} className="h-full bg-[var(--fg)] rounded-full" data-id="element-167" />
            </div>
            <div className="flex justify-between mt-2 text-xs font-bold text-[var(--muted)] uppercase tracking-wider" data-id="element-168">
              <span data-id="element-169">Month 1</span>
              <span data-id="element-170">Month 6</span>
              <span data-id="element-171">Month 12</span>
            </div>
          </div>
        </motion.div>
      </div>
    </InteriorSlide>;
}